import { ErrorHandler } from '@angular/core';

import { SentryErrorHandler } from './services/error-handler.service';

export const errorHandlerProvider = {
  provide: ErrorHandler,
  useClass: SentryErrorHandler,
};
